import React from 'react';
import i18n from 'i18next';
import { AutoTable, InfoText, Icon, Status } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './selected-widgets.module.css';

export function EventStatus({ event, obj }) {
    const { t } = useTranslation();

    return <Status text={t('eventStatus.' + event.status)} color={event.status === 'draft' ? 'orange' : ['closed', 'over'].includes(event.status) ? 'red' : 'green'} />;
}

export function SelectedWidgets({ widgets = [], onRemoveWidget = () => {} }) {
    const { t } = useTranslation();

    const formatter = new Intl.DateTimeFormat(i18n.language, {
        dateStyle: 'short',
        timeStyle: 'short'
    });

    if (!widgets.length) {
        return null;
    }

    return (
        <AutoTable
            pk="id"
            useNew
            className={Style['event-tab']}
            columns={[
                {
                    key: 'event_name',
                    label: t('ticket.widgets.event.selected_events.events'),
                    render: obj => {
                        return <InfoText subtitle={`${formatter.format(new Date(obj.event?.start_date))} • E${obj.event.id}`}>{obj.event.name}</InfoText>;
                    }
                },
                {
                    key: 'widget_name',
                    label: t('ticket.widgets.event.selected_events.widgets'),
                    render: obj => <InfoText>{obj.name}</InfoText>
                },
                {
                    key: 'event_status',
                    label: t('ticket.widgets.event.selected_events.status'),
                    render: obj => <EventStatus event={obj.event} />
                },
                {
                    key: 'delete',
                    render: obj => {
                        return <Icon name="cross" onClick={() => onRemoveWidget(obj)} />;
                    }
                }
            ]}
            objects={[...widgets]}
        />
    );
}
